import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { fonts, colors } from "../../../styles/variables";

const RadioLabel = styled.label`
  display: block;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

const RadioText = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  border: 1px solid ${colors.silver};
  padding: 45px 20px;
`;

const RadioTextLabel = styled.p`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 35px;
  line-height: 1;
  margin-bottom: 5px;
`;

const RadioTextSubLabel = styled.p`
  font-family: ${fonts.fontConceptRegular};
`;

const RadioInput = styled.input`
  display: none;
  opacity: 0;
  visibility: hidden;
  &[aria-checked="true"] + ${RadioText} {
    border: 1px solid ${colors.black};
  }
`;

const CellarRadio = (
  {
    label = "",
    sublabel = "",
    value = "",
    isDefault = false,
    danger = false,
    success = false,
    forceChecked = false,
  },
  context
) => {
  const {
    radioGroup: { name, selectedValue, onChange, disabled },
  } = context;
  const isCheckedByDefault = selectedValue === null && isDefault;
  const isChecked = value === selectedValue || isCheckedByDefault;
  return (
    <RadioLabel disabled={disabled}>
      <RadioInput
        value={value}
        aria-checked={isChecked || forceChecked}
        type="radio"
        name={name}
        onChange={onChange}
        checked={isChecked || forceChecked}
        danger={danger}
        success={success}
        disabled={disabled}
      />
      <RadioText>
        <RadioTextLabel>{label}</RadioTextLabel>
        <RadioTextSubLabel>{sublabel}</RadioTextSubLabel>
      </RadioText>
    </RadioLabel>
  );
};

CellarRadio.contextTypes = {
  radioGroup: PropTypes.shape({}),
};

CellarRadio.propTypes = {
  isDefault: PropTypes.bool,
  label: PropTypes.string,
  sublabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  danger: PropTypes.bool,
  success: PropTypes.bool,
  forceChecked: PropTypes.bool,
};

export default CellarRadio;
